import * as Icons from '@ant-design/icons';
import type React from 'react';

import { CUSTOM_ICONS } from './icons';

const ALL_ICONS = { ...Icons, ...CUSTOM_ICONS };

export type IconName = keyof typeof ALL_ICONS;

const AntIcon = ({
  name,
  ...props
}: { name: IconName } & React.ComponentProps<any>): React.ReactNode => {
  const Component = ALL_ICONS[name as IconName] as any;

  if (!Component) return null;
  return <Component {...props} />;
};

export default AntIcon;
